import { trackMetric } from '../Telemetry/Telemetry.ts'
import type { WizardEntrySource, WizardEntryVia } from './handoff.ts'

/**
 * How the order wizard's exact-primer estimate compared with the primers a sample sheet declared, once
 * per sample and sheet. Outcome categories only — never a sequence or primer string. Group by
 * `org_id` (attached automatically, as is `is_internal`) for per-lab accuracy.
 */
export const trackPrimerEstimateOutcome = (
  outcome: 'correct' | 'tag_mismatch' | 'sheet_untagged' | 'gene_spelling' | 'no_estimate',
  spelling: 'lab' | 'registry'
): void => {
  trackMetric('order_wizard.primer_estimate', { outcome, spelling })
}

/*
 * `order_wizard.funnel`, one counter whose `stage` is:
 * - `entered`: once per wizard page visit. `source` is where the lab came from (`dashboard`,
 *   `classic-create`, or `direct` for a URL, bookmark or back navigation); `via` is how (`drop`, `pick`,
 *   `link`), absent for `direct`.
 * - `submitted`: an order submitted from the wizard.
 * - `continued_classic`: a click through to the classic order view; `from` names the link.
 * The org bundle and `is_internal` come with every count.
 */

export const trackWizardEntered = (source: WizardEntrySource, via?: WizardEntryVia): void => {
  trackMetric('order_wizard.funnel', { stage: 'entered', source, via })
}

export const trackWizardSubmitted = (): void => {
  trackMetric('order_wizard.funnel', { stage: 'submitted' })
}

export type ClassicViewLink = 'header' | 'review' | 'unrestorable' | 'submitted-metadata'

export const trackWizardContinuedInClassic = (from: ClassicViewLink): void => {
  trackMetric('order_wizard.funnel', { stage: 'continued_classic', from })
}
